const SECONDS_TO_MS = 1e3;
const MINUTES_TO_MS = 60 * SECONDS_TO_MS;
const HOURS_TO_MS = 60 * MINUTES_TO_MS;
const DAYS_TO_MS = 24 * HOURS_TO_MS;

export { DAYS_TO_MS, HOURS_TO_MS, MINUTES_TO_MS, SECONDS_TO_MS };
//# sourceMappingURL=time.js.map
